<template>
    <form class="form">
        <div :id="`checboxes_q_${question.id}`">
            <div class="form__item--checkbox" >
                <div class="form__checkbox" v-for="option in question.options" :key="option.id">
                    <input
                        type="checkbox"
                        :id="`q_${question.id}_cb_o_${option.id}`"
                        :name="`q_${question.id}_cb_o_${option.id}`"
                        :value="`q_${question.id}_cb_o_${option.id}`"
                        class="form__checkbox__input"
                        v-model="checkboxes"
                        :disabled="locked" />
                    <label class="form__checkbox__label" :for="`q_${question.id}_cb_o_${option.id}`">{{option.label}}</label>
                </div>

                <div class="form__checkbox" v-if="question.allow_other">
                    <input
                        type="checkbox"
                        :id="`q_${question.id}_cb_o_other`"
                        :name="`q_${question.id}_cb_o_other`"
                        :value="`q_${question.id}_cb_o_other`"
                        class="form__checkbox__input"
                        v-model="checkboxes"
                        :disabled="locked" />
                    <label class="form__checkbox__label" :for="`q_${question.id}_cb_o_other`">{{$t('forms.survey_template_question.other_label')}}</label>
                </div>
            </div>
        </div>
        <div class="form__item" v-if="checkboxes.includes(`q_${question.id}_cb_o_other`)">
            <input v-model="otherAnswer" class="form__input--text" type="text" :class="{ 'has-value': otherAnswer }" :disabled="locked"/>
            <label class="form__label">{{$t('forms.survey_template_question.other_label')}}</label>
        </div>
    </form>
</template>

<script>
    import Vue from 'vue';
    import { Component, Prop, Model } from 'vue-property-decorator';

    @Component
    export default class SurveyTemplateQuestionForm extends Vue {
        @Model('change', { type: Object, default() {
            return {
                answer: '',
                options: []
            };
        }})
        question;

        @Prop() locked;

        get checkboxes() {
            return this.question.answer ? JSON.parse(this.question.answer).checkboxes : [];
        }

        set checkboxes(cbs) {
            const answer = JSON.stringify({checkboxes: cbs, other: this.otherAnswer});
            Vue.set(this.question, 'answer', answer);
        }

        get otherAnswer() {
            return this.question.answer ? JSON.parse(this.question.answer).other : '';
        }

        set otherAnswer(answer) {
            this.question.answer = JSON.stringify({checkboxes: this.checkboxes, other: answer});
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/forms/survey/SurveyQuestionMultipleForm.vue